(function() {
    var hdr = document.getElementById("hdr");
    function sc() {
        hdr.classList.toggle("scrolled", window.scrollY > 24);
    }
    window.addEventListener("scroll", sc, {
        passive: true
    });
    sc();
    var io = new IntersectionObserver(function(es) {
        es.forEach(function(e) {
            if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
            }
        });
    }, {
        threshold: .12
    });
    document.querySelectorAll(".rv").forEach(function(el) {
        io.observe(el);
    });
    var vio = new IntersectionObserver(function(es) {
        es.forEach(function(e) {
            var v = e.target;
            if (e.isIntersecting) v.play().catch(function() {});
            else v.pause();
        });
    }, {
        threshold: .25
    });
    document.querySelectorAll("video[data-io]").forEach(function(v) {
        vio.observe(v);
    });
})();

//# sourceMappingURL=wildz.d2438b25.js.map
